import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  boxButtons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    gap: theme.spacing(1),
  },
}))

export default styles
